import styled from "styled-components";
import { breakpoints } from "../../constants/media";

const Container = styled.div`
    width: 100%;
    max-width: 1270px;
    display: flex;
    justify-content:  ${(props) => props.center ? "center" : "flex-start"};
    flex-wrap: wrap;
    flex-direction: row;
    
  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
      max-width: 1000px;
    
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
      max-width: 680px;
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
      max-width: 480px;
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
      max-width: 380px;
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
      max-width: 85%;
  }
`;

export default Container;
